import ERP from "@apiV2/ERP.mjs";

// Helpers compartilhados pelos "Relatório Geral de Pedido de Compra" e "Relatório Geral de
// Ordem de Pagamento". Datas ficam como "YYYY-MM-DD" (string) para evitar deslocamento de
// fuso (um "...T00:00:00Z" exibido em horário local viraria o dia anterior).

export const toNumber = (valor) => {
  const n = Number(valor);
  return Number.isFinite(n) ? n : 0;
};

export const toIsoDay = (valor) => {
  if (!valor) return "";
  const texto = String(valor).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(texto)) return texto.slice(0, 10);
  const d = new Date(texto);
  if (Number.isNaN(d.getTime())) return "";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
};

export const hojeIso = () => toIsoDay(new Date());

export const formatarDia = (iso) => {
  const dia = toIsoDay(iso);
  if (!dia) return "";
  const [a, m, d] = dia.split("-");
  return `${d}/${m}/${a}`;
};

export const diasEntre = (isoInicio, isoFim) => {
  const a = Date.parse(`${toIsoDay(isoInicio)}T00:00:00Z`);
  const b = Date.parse(`${toIsoDay(isoFim)}T00:00:00Z`);
  if (Number.isNaN(a) || Number.isNaN(b)) return 0;
  return Math.round((b - a) / 86400000);
};

export const unicos = (lista = []) =>
  Array.from(new Set(lista.filter((v) => v !== null && v !== undefined && String(v).trim() !== "")));

export const emLotes = (lista = [], tamanho = 40) => {
  const lotes = [];
  for (let i = 0; i < lista.length; i += tamanho) lotes.push(lista.slice(i, i + tamanho));
  return lotes;
};

// URLs com centenas de ids falham ("Failed to fetch"), então toda busca em lote é quebrada.
export const getManyByIdEmLotes = async (schema, ids = []) => {
  const resultado = [];
  for (const lote of emLotes(unicos(ids))) {
    const resposta = await ERP.getManyById(schema, lote);
    if (resposta?.status === 200 && Array.isArray(resposta.data)) resultado.push(...resposta.data);
  }
  return resultado;
};

export const textoDe = (valor) => {
  if (valor === null || valor === undefined) return "";
  if (typeof valor === "object") {
    return String(valor.nome || valor.name || valor.descricao || valor.description || valor.codigo || "").trim();
  }
  return String(valor).trim();
};

export const idDe = (valor) => (valor && typeof valor === "object" ? valor.id || valor._id || "" : valor || "");

const STATUS_PAGO = "Pagamento Realizado";

// Resume as contas a pagar (parcelas) de um grupo da view "contas-a-pagar".
export const resumirContasAPagar = (grupo) => {
  const soma = {
    valorOriginal: 0, valorParaReservar: 0, valorDesconto: 0, valorPagamento: 0, valorReservado: 0,
    valorParaPagar: 0, valorPago: 0, valorParaVincular: 0, valorVinculado: 0
  };
  const parcelas = [];
  let ultimoPagamento = "";

  (grupo?.parcelas || []).forEach((parcela) => {
    const conta = parcela?.contaAPagar || {};
    Object.keys(soma).forEach((campo) => { soma[campo] += toNumber(conta[campo]); });

    (Array.isArray(conta.pagamentos) ? conta.pagamentos : []).forEach((pg) => {
      const realizado = !pg?.status || String(pg.status).trim().toLowerCase() === STATUS_PAGO.toLowerCase();
      const dia = toIsoDay(pg?.dataPagamento || pg?.dataCriacao);
      if (realizado && dia && dia > ultimoPagamento) ultimoPagamento = dia;
    });

    parcelas.push({
      vencimento: toIsoDay(conta.dataVencimento || parcela?.dataVencimento),
      status: conta.status || "",
      valorOriginal: toNumber(conta.valorOriginal),
      valorPago: toNumber(conta.valorPago),
      valorParaPagar: toNumber(conta.valorParaPagar),
      valorDesconto: toNumber(conta.valorDesconto),
      valorPagamento: toNumber(conta.valorPagamento)
    });
  });

  parcelas.sort((a, b) => (a.vencimento || "9999").localeCompare(b.vencimento || "9999"));
  return { soma, parcelas, ultimoPagamento, existe: parcelas.length > 0 };
};

// Parcela vencida = vencimento antes de hoje e ainda com saldo a liquidar.
export const maiorAtraso = (parcelas = [], hoje = hojeIso()) => {
  let atraso = 0;
  parcelas.forEach((p) => {
    if (!p.vencimento || p.vencimento >= hoje) return;
    if (/cancel/i.test(p.status || "")) return;
    const aberto = p.valorOriginal - p.valorPago;
    if (aberto > 0.009) atraso = Math.max(atraso, diasEntre(p.vencimento, hoje));
  });
  return atraso;
};
